import type { KeyboardEventHandler } from 'react';
import { useCallback } from 'react';

import { useSDK, useUIState } from './../../../../../app/App';

export const useOnKeyPress = (onSendClick: VoidFunction): KeyboardEventHandler<HTMLTextAreaElement> => {
	const { startNewConversationRequestStatus, newConversationHistoryRequestStatus } = useSDK();
	const { attachmentErrorsStore } = useUIState();
	return useCallback(
		(e) => {
			attachmentErrorsStore.error && attachmentErrorsStore.clearError();
			if (e.key === 'Enter' && !e.shiftKey) {
				e.preventDefault();
				!startNewConversationRequestStatus.isPending &&
					!newConversationHistoryRequestStatus.isPending &&
					onSendClick();
			}
		},
		[
			newConversationHistoryRequestStatus.isPending,
			onSendClick,
			attachmentErrorsStore,
			startNewConversationRequestStatus,
		]
	);
};
